import React from "react";
import { colors } from "../../global";

const TableEditor = ({ tableData, setTableData }) => {
  const addRow = () => {
    setTableData([...tableData, new Array(tableData[0]?.length || 2).fill("")]);
  };

  const addColumn = () => {
    setTableData(tableData.map((row) => [...row, ""]));
  };

  const updateCell = (rowIndex, colIndex, value) => {
    const updated = [...tableData];
    updated[rowIndex][colIndex] = value;
    setTableData(updated);
  };

  const removeRow = (rowIndex) => {
    if (tableData.length > 1) {
      setTableData(tableData.filter((_, idx) => idx !== rowIndex));
    }
  };

  const removeColumn = (colIndex) => {
    if (tableData[0]?.length > 1) {
      setTableData(
        tableData.map((row) => row.filter((_, idx) => idx !== colIndex))
      );
    }
  };

  return (
    <div
      className="mt-4 p-4 rounded-lg border"
      style={{
        backgroundColor: colors.white,
        borderColor: colors.gray + "80",
      }}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div
            className="w-2 h-2 rounded-full"
            style={{ backgroundColor: colors.mutedBlue }}
          ></div>
          <span
            className="text-sm font-semibold"
            style={{ color: colors.primary }}
          >
            Table Editor
          </span>
        </div>
        <div className="flex gap-2">
          <button
            onClick={addRow}
            className="px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-200 hover:shadow-sm"
            style={{
              backgroundColor: colors.secondary,
              color: colors.white,
            }}
          >
            + Row
          </button>
          <button
            onClick={addColumn}
            className="px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-200 hover:shadow-sm"
            style={{
              backgroundColor: colors.secondary,
              color: colors.white,
            }}
          >
            + Column
          </button>
        </div>
      </div>

      <div className="overflow-x-auto">
        <div className="min-w-full">
          <table className="w-full">
            <tbody>
              {tableData.map((row, rowIndex) => (
                <tr key={rowIndex} className="group">
                  {row.map((cell, colIndex) => (
                    <td key={colIndex} className="p-1.5">
                      <input
                        value={cell}
                        onChange={(e) =>
                          updateCell(rowIndex, colIndex, e.target.value)
                        }
                        className="w-full px-3 py-2 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-offset-1 transition-all duration-200"
                        style={{
                          borderColor: colors.darkGray + "40",
                          backgroundColor: colors.gray + "30",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = colors.primary;
                          e.target.style.backgroundColor = colors.white;
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = colors.darkGray + "40";
                          e.target.style.backgroundColor = colors.gray + "30";
                        }}
                        placeholder={
                          rowIndex === 0
                            ? `Header ${colIndex + 1}`
                            : `Row ${rowIndex} Col ${colIndex + 1}`
                        }
                      />
                    </td>
                  ))}
                  <td className="p-1.5 w-10">
                    <button
                      onClick={() => removeRow(rowIndex)}
                      className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all duration-200 opacity-0 group-hover:opacity-100 hover:scale-105 disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:scale-100"
                      style={{
                        backgroundColor: colors.error + "10",
                        color: colors.error,
                        border: `1px solid ${colors.error}30`,
                      }}
                      onMouseEnter={(e) => {
                        if (!e.target.disabled) {
                          e.target.style.backgroundColor = colors.error;
                          e.target.style.color = colors.white;
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!e.target.disabled) {
                          e.target.style.backgroundColor = colors.error + "10";
                          e.target.style.color = colors.error;
                        }
                      }}
                      disabled={tableData.length <= 1}
                      title="Remove row"
                    >
                      x
                    </button>
                  </td>
                </tr>
              ))}
              <tr>
                {tableData[0]?.map((_, colIndex) => (
                  <td key={colIndex} className="p-1.5">
                    <button
                      onClick={() => removeColumn(colIndex)}
                      className="w-full h-8 rounded-md flex items-center justify-center text-xs font-medium transition-all duration-200 hover:scale-105 disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:scale-100"
                      style={{
                        backgroundColor: colors.error + "10",
                        color: colors.error,
                        border: `1px solid ${colors.error}30`,
                      }}
                      onMouseEnter={(e) => {
                        if (!e.target.disabled) {
                          e.target.style.backgroundColor = colors.error;
                          e.target.style.color = colors.white;
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!e.target.disabled) {
                          e.target.style.backgroundColor = colors.error + "10";
                          e.target.style.color = colors.error;
                        }
                      }}
                      disabled={tableData[0]?.length <= 1}
                      title="Remove column"
                    >
                      x
                    </button>
                  </td>
                ))}
                <td className="p-1.5 w-10"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        className="mt-3 pt-3 border-t flex items-center justify-between text-xs"
        style={{ borderColor: colors.gray }}
      >
        <span style={{ color: colors.darkGray }}>
          {tableData.length} rows x {tableData[0]?.length || 0} columns
        </span>
        <span style={{ color: colors.darkGray }}>
          Click cells to edit, hover rows to remove
        </span>
      </div>
    </div>
  );
};

export default TableEditor;
